import {RouteConfig} from 'vue-router';
import { Routes } from '@/router/Routes';
import AuthService from '@/modules/user/AuthService';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import QuizzesView from '@/modules/Quizzes/views/QuizzesView.vue';
const Statements = () => import('@/modules/Statements/views/Statements.vue');
const PermissionsList = () => import(/* webpackChunkName: "Permissions" */'../views/permissions-list/PermissionsList.vue');

const AccreditationPanelRoutes: Array<RouteConfig> = [
  {
    path: 'permissions_banks',
    name: Routes.ACCREDITATION_PANEL.PERMISSIONS_BANKS,
    meta: {
      title: I18NGetter().PlatformSection.permissions,
      icon: 'mdi-key-variant',
      condition: () => !AuthService.User?.isFinpackClient && !AuthService.User?.privileges.simplePartnerView,
    },
    component: PermissionsList,
  },
  {
    path: 'compliance',
    name: Routes.ACCREDITATION_PANEL.COMPLIANCE,
    meta: {
      title: I18NGetter().PlatformSection.statements,
      icon: 'mdi-file-sign',
    },
    component: Statements,
  },
  {
    path: 'quizzes_panel',
    name: Routes.ACCREDITATION_PANEL.QUIZZES_PANEL,
    meta: {
      title: I18NGetter().PlatformSection.quizzes_panel,
      icon: 'mdi-clipboard-text',
    },
    component: QuizzesView,
  },
];

export default AccreditationPanelRoutes;
